import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What areas do you serve?",
  answer: "We proudly serve the greater metropolitan area and surrounding counties. If you are unsure whether you fall within our service area, please contact us, and we will be happy to let you know."
}, {
  question: "Do you offer free estimates?",
  answer: "Yes—free estimates, no pressure. We'll walk you through the whole project upfront. for all our exterior services, including roofing, siding, and storm damage repair. Our team will come out, look things over, and give you honest pricing."
}, {
  question: "How long does a typical roof replacement take?",
  answer: "Most residential roof replacements can be completed in 1 to 2 days, depending on the size and complexity of the roof, as well as weather conditions. We strive to minimize disruption to your daily life while ensuring high-quality workmanship."
}, {
  question: "Are you licensed and insured?",
  answer: "Absolutely. We are fully licensed, bonded, and insured. This protects both our workers and your property throughout the duration of the project, giving you complete peace of mind."
}, {
  question: "Do you help with insurance claims for storm damage?",
  answer: "Yes, we have extensive experience working with insurance companies. We can perform a thorough inspection, document the damage, and guide you through the entire claims process to help ensure you receive the coverage you deserve."
}, {
  question: "What types of roofing materials do you install?",
  answer: "We work with a wide variety of high-quality materials, including asphalt shingles, metal roofing, cedar shakes, and flat roofing systems. We can help you choose the best option based on your budget, aesthetic preferences, and durability requirements."
}];
export default function FrequentlyAskedQuestions() {
  return <section id="frequently-asked-questions" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Find answers to common questions about our exterior services, processes, and policies.
          </p>
        </div>

        <div className="bg-card border border-border rounded-lg shadow-sm p-4 md:p-6">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-left font-default text-base md:text-lg hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center bg-muted/50 rounded-lg p-8 border border-border/50">
          <h3 className="text-xl font-semibold font-default mb-2">Still have questions?</h3>
          <p className="text-muted-foreground mb-6">
            Can't find the answer you're looking for? Please chat to our friendly team.
          </p>
          <Button asChild size="lg" className="font-semibold">
            <Link to="/ContactPage">Get in Touch</Link>
          </Button>
        </div>

      </div>
    </section>;
}